package top.wcpe.allincore.dsl.compiler.parse

import top.wcpe.allincore.dsl.compiler.ast.ThemeFileAst

/**
 * 顶级 `theme { ... }` 文件解析器。
 *
 * 与 screen 内的 [ThemeBlockParser] 共用 token 解析逻辑：完整委托 ThemeBlockParser 后
 * 包装到 [ThemeFileAst]，scheme 名由外部（Pipeline）从文件名推导后注入。
 */
internal class ThemeFileParser(private val p: Parser) {

    fun parse(): ThemeFileAst {
        val pos = p.current().position
        val blockParser = ThemeBlockParser(p)
        val parsed = blockParser.parse()
        val position = p.completePosition(pos)
        p.skipNewlines()
        // schemeName 由 Pipeline 在构造 ThemeFileAst 后覆盖；此处暂用 screenId 占位
        // metadata 经 ThemeBlockParser.lastMetadata 透出；tokenNodes 从 ThemeAst sidecar 复制。
        return ThemeFileAst(parsed.tokens, p.screenId, blockParser.lastMetadata(), position).also {
            it.tokenNodes = LinkedHashMap(parsed.tokenNodes)
        }
    }
}
